import React from 'react'
import style from './articles.style'

const EnvyCrm = ({ classes }) => {
  return (
    <article className={classes.article}>
      <h2>Подключение Envy CRM</h2>

      <h3>CRM ID</h3>
      <p>
        Перейдите в раздел "Настройки" -> "Интеграция" -> "Сайты" и скопируйте код, как показано на скриншоте. Этот код - CRM ID. Его необходимо указать при подключении CRM в личном кабинете Дата Споттера
      </p>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/envycrmhelp1.png" alt="true" />
        <figcaption>Подключение EnvyCRM</figcaption>
      </figure>

      <h3>API</h3>
      <p>
        Перейдите в раздел "Настройки" -> "Интеграция" -> "API", включите и скопируйте ключ API. Его необходимо указать при подключении CRM в личном кабинете Дата Споттера
      </p>

      <h3>Webhooks</h3>
      <p>
        Для передачи сделок в Дата Споттер необходимо настроить Webhooks. 
        <br/>Для этого перейдите в раздел "Настройки" -> "Интеграция" -> "WebHook".
        <br/><br/>Укажите адрес, на который будут отправляться уведомления: https://romi.center/api/envy
        <br/>Отметьте события: Изменение этапа заявки, Изменение этапа сделки
      </p>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/envycrmhelp2.png" alt="true" />
        <figcaption>Подключение EnvyCRM</figcaption>
      </figure>
    </article>
  )
}

export default style(EnvyCrm)
